/** Derive a stable service offering slug from a human label (lowercase, underscores). */
export function slugifyServiceOfferingLabel(label: string): string {
  const cleaned = label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 64);
  return cleaned || "service";
}
